import React, { useEffect, useState } from 'react';
import {
  type AddressTemplate,
  ExternalDataProvider,
  FormStatusProvider,
} from '@wix/form-fields';
import { FormViewerProvider } from '@wix/form-viewer';
import type { i18n as I18nType } from '@wix/fe-essentials/i18n';

import type { Currency } from '../types/types';
import { createI18n, FORM_VIEWER_NAMESPACE } from './create-i18n';

export interface FormProviderProps {
  children: React.ReactNode;
  currency: Currency;
  locale: string;
  regionalFormat?: string;
  addressTemplates?: AddressTemplate[];
}

export const FormProvider = ({
  children,
  currency,
  locale,
  addressTemplates,
  regionalFormat = 'en',
}: FormProviderProps) => {
  const [i18nInstance, setI18nInstance] = useState<I18nType | null>(null);

  useEffect(() => {
    const initializeI18n = async () => {
      try {
        const newI18n = await createI18n(locale);
        setI18nInstance(newI18n);
      } catch (error) {
        console.error('Failed to initialize i18n:', error);
      }
    };

    initializeI18n();
  }, [locale]);

  if (!i18nInstance) {
    return null;
  }

  return (
    <FormViewerProvider
      i18n={i18nInstance}
      form={{}}
      language={locale}
      regionalFormat={regionalFormat}
      currency={currency}
      translationNamespace={FORM_VIEWER_NAMESPACE}
      WixRicosViewer={() => null}
      addressTemplates={addressTemplates}
    >
      <ExternalDataProvider externalData={{}}>
        <FormStatusProvider>{children}</FormStatusProvider>
      </ExternalDataProvider>
    </FormViewerProvider>
  );
};
